import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
import { Radio } from '../checkbox/Radio';
export class RadioGroup extends React.PureComponent {
    static count = 0;
    id = '';
    constructor(props) {
        super(props);
        this.id = 'TmRadioGroup' + ++RadioGroup.count; // unique ID for DOM
    }
    render() {
        return (_jsx("div", { className: classNames({
                'sg-a-d-f sg-a-rg-1': true,
                'sg-a-ai-b sg-a-fw-w sg-a-cg-2': this.props.direction === 'row',
                'sg-a-fd-c': this.props.direction !== 'row',
            }), children: this.props.items.map((item, index) => (_jsx(Radio, { value: item.value, name: this.props.name || this.id, isChecked: this.props.value !== undefined ? item.value === this.props.value : undefined, isDefaultChecked: this.props.defaultValue !== undefined
                    ? item.value === this.props.defaultValue
                    : undefined, isDisabled: this.props.isDisabled, isInvalid: this.props.isInvalid, onChange: this.props.onChange, testId: this.props.testId ? `${this.props.testId}-item-${index + 1}` : undefined, children: this.props.renderItem ? this.props.renderItem(item) : item.label }, item.value))) }));
    }
}
//# sourceMappingURL=RadioGroup.js.map